var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path0, _path1, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVivienda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_vivienda_lineal_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.001,
    height: 64.998,
    viewBox: "0 0 65.001 64.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104896",
    "data-name": "Trazado 104896",
    d: "M7761.833,5288.965v31.847h54.484v-31.847l-27.3-27.062Z",
    transform: "translate(-7756.38 -5256.466)",
    fill: "#fce3ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104894",
    "data-name": "Trazado 104894",
    d: "M7764.923,5331.879h-6.236s-3.512-1.472-2.539-3.846a4.536,4.536,0,0,1,3.366-2.7s3.173.894,3.3,1.832.721-1.832.721-1.832a3.9,3.9,0,0,1,3.3-2.342c2.337-.035,3.753,2.342,3.753,2.342l1.118,2.7s2.382.446,2.194,1.953-2.194,1.893-2.194,1.893h-6.777",
    transform: "translate(-7755.272 -5268.021)",
    fill: "#8dc13a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104895",
    "data-name": "Trazado 104895",
    d: "M7764.96,5331.879h6.236s3.512-1.472,2.539-3.846a4.537,4.537,0,0,0-3.366-2.7s-3.174.894-3.3,1.832-.721-1.832-.721-1.832a3.9,3.9,0,0,0-3.3-2.342c-2.337-.035-3.753,2.342-3.753,2.342l-1.118,2.7s-2.382.446-2.193,1.953,2.193,1.893,2.193,1.893h6.778",
    transform: "translate(-7708.905 -5268.021)",
    fill: "#8dc13a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104892",
    "data-name": "Trazado 104892",
    d: "M7769.482,5308.275h8.92v-6.311h-8.92Z",
    transform: "translate(-7757.827 -5264.043)",
    fill: "#7eccc9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104897",
    "data-name": "Trazado 104897",
    d: "M7769.482,5308.275h8.92v-6.311h-8.92Z",
    transform: "translate(-7757.827 -5258.367)",
    fill: "#faeec4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104898",
    "data-name": "Trazado 104898",
    d: "M7769.482,5308.275h8.92v-6.311h-8.92Z",
    transform: "translate(-7724.954 -5258.367)",
    fill: "#faeec4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104893",
    "data-name": "Trazado 104893",
    d: "M7769.482,5308.275h8.92v-6.311h-8.92Z",
    transform: "translate(-7724.954 -5264.043)",
    fill: "#7eccc9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1554",
    "data-name": "Elipse 1554",
    cx: 2.838,
    cy: 2.838,
    r: 2.838,
    transform: "translate(29.914 18.489)",
    fill: "#faeec4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104891",
    "data-name": "Trazado 104891",
    d: "M7788.48,5323.595v-22.116h10.983v22.116Z",
    transform: "translate(-7761.42 -5263.951)",
    fill: "#5a3f3f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104890",
    "data-name": "Trazado 104890",
    d: "M7771.726,5264.968v-4.213h-2.243v-4.583h9v4.583H7776.2v4.213Z",
    transform: "translate(-7757.827 -5255.382)",
    fill: "#e68383"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104888",
    "data-name": "Trazado 104888",
    d: "M7756.654,5294.008V5267.02h26.375Z",
    transform: "translate(-7755.401 -5257.434)",
    fill: "#7eccc9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104889",
    "data-name": "Trazado 104889",
    d: "M7783.029,5294.008V5267.02h-26.375Z",
    transform: "translate(-7718.84 -5257.434)",
    fill: "#7eccc9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16621",
    "data-name": "Grupo 16621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.25,27.083H4.334a4.333,4.333,0,1,1,0-8.667V1.083a1.083,1.083,0,0,1,2.166,0V18.95a4.409,4.409,0,0,1,.552.335,5.448,5.448,0,0,1,1.963-2.191,5.419,5.419,0,0,1,8.238,3.647,3.25,3.25,0,0,1-1,6.342Zm-11.916-6.5a2.167,2.167,0,1,0,0,4.333H16.25a1.083,1.083,0,1,0,0-2.166,1.084,1.084,0,0,1-1.083-1.083,3.25,3.25,0,0,0-6.5,0,1.082,1.082,0,0,1-.89,1.066,1.082,1.082,0,0,1-1.207-.687A2.355,2.355,0,0,0,4.334,20.582Z",
    transform: "translate(0 37.915)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M63.916,8.666H43.333a1.083,1.083,0,1,0,0,2.167h19.5V34.217L33.266,4.651a1.091,1.091,0,0,0-1.538,0L2.167,34.216V10.833H14.083A1.084,1.084,0,0,0,15.167,9.75V5.417a1.084,1.084,0,0,0-1.083-1.083H13V2.167h6.5V4.333H18.416a1.084,1.084,0,0,0-1.083,1.083V9.75a1.084,1.084,0,0,0,1.083,1.083h3.25a1.083,1.083,0,1,0,0-2.167H19.5V6.5h1.083a1.084,1.084,0,0,0,1.083-1.083V1.083A1.084,1.084,0,0,0,20.583,0H11.917a1.084,1.084,0,0,0-1.083,1.083V5.416A1.084,1.084,0,0,0,11.917,6.5H13V8.666H1.083A1.084,1.084,0,0,0,0,9.75L0,36.832a1.083,1.083,0,0,0,1.849.766L32.5,6.945,63.15,37.6A1.083,1.083,0,0,0,65,36.832V9.75A1.084,1.084,0,0,0,63.916,8.666Z",
    transform: "translate(0 0)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M34.668,27.082H1.083a1.083,1.083,0,1,1,0-2.166H19.7a3.161,3.161,0,0,1-.2-1.083,3.244,3.244,0,0,1,2.246-3.091,5.417,5.417,0,0,1,10.2-1.456,4.485,4.485,0,0,1,.553-.335V1.083a1.083,1.083,0,0,1,2.166,0V18.416a4.333,4.333,0,0,1,0,8.666Zm-7.585-8.666a3.254,3.254,0,0,0-3.25,3.25A1.084,1.084,0,0,1,22.75,22.75a1.083,1.083,0,1,0,0,2.166H34.666a2.166,2.166,0,1,0,0-4.333,2.353,2.353,0,0,0-2.235,1.462,1.084,1.084,0,0,1-2.1-.379A3.254,3.254,0,0,0,27.083,18.416Z",
    transform: "translate(26 37.915)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M4.334,8.666A4.333,4.333,0,1,1,8.666,4.333,4.338,4.338,0,0,1,4.334,8.666Zm0-6.5A2.167,2.167,0,1,0,6.5,4.333,2.17,2.17,0,0,0,4.334,2.166Z",
    transform: "translate(28.166 17.333)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M14.083,15.167h-13a1.084,1.084,0,0,1,0-2.167H2.166V1.083A1.084,1.084,0,0,1,3.249,0h8.667A1.084,1.084,0,0,1,13,1.083V13h1.083a1.084,1.084,0,1,1,0,2.167Zm-9.749-6.5V13h6.5V8.667Zm0-6.5V6.5h6.5V2.166Z",
    transform: "translate(41.166 36.832)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M1.083,28.166A1.085,1.085,0,0,1,0,27.082V22.75a1.084,1.084,0,0,1,1.083-1.083h3.25V1.083A1.084,1.084,0,0,1,5.417,0H16.25a1.084,1.084,0,0,1,1.083,1.083V21.666h3.249a1.083,1.083,0,1,1,0,2.166H2.166v3.249A1.085,1.085,0,0,1,1.083,28.166Zm5.417-26v19.5h8.666V13H14.083a1.083,1.083,0,1,1,0-2.166h1.083V2.166Z",
    transform: "translate(21.667 36.832)",
    fill: "#3b0310"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M14.083,15.167h-13a1.084,1.084,0,0,1,0-2.167H2.166V1.083A1.085,1.085,0,0,1,3.25,0h8.666A1.084,1.084,0,0,1,13,1.083V13h1.083a1.084,1.084,0,1,1,0,2.167Zm-9.749-6.5V13h6.5V8.667Zm0-6.5V6.5h6.5V2.166Z",
    transform: "translate(8.667 36.832)",
    fill: "#3b0310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivienda);
export default __webpack_public_path__ + "static/media/vivienda.8a78243120846eaa1125caf44cdbeff4.svg";
export { ForwardRef as ReactComponent };